import { ref } from "vue";
import { GET_SERVER_REQUEST, imageUrl, SERVER_REQUEST } from "./ServerConnect";
import { SendErrorLog } from "./GlobalUtility";
import { resetStateColorSettings } from "./ColorUtility";
import { resetMarkerGroupingRange, Set_Default_Map_Setting } from "./MapSetting";

const All_Setting_List = ref(null);

const Use_QLS_Users = ref();

const UpdateTime_Status_Range = ref([]);
const Marker_Grouping_Range = ref();
const Battery_Level_Range = ref();
const Cell_Power_Range = ref();

const Map_Default_Location = ref();
const Marker_Default_Icon = ref();
const Group_Default_Icon = ref();

export const Get_All_Settings_FromServer = async () => {
  All_Setting_List.value = await GET_SERVER_REQUEST('setting');

  Use_QLS_Users.value = All_Setting_List.value.find(setting => setting.setting_name === 'use_qls_users');

  UpdateTime_Status_Range.value = All_Setting_List.value.find(setting => setting.setting_name === 'updatetime_status_range');
  if (UpdateTime_Status_Range.value) resetStateColorSettings();

  Marker_Grouping_Range.value = All_Setting_List.value.find(setting => setting.setting_name === 'marker_grouping_range');
  if (Marker_Grouping_Range.value) resetMarkerGroupingRange();

  Battery_Level_Range.value = All_Setting_List.value.find(setting => setting.setting_name === 'battery_level_range');
  Cell_Power_Range.value = All_Setting_List.value.find(setting => setting.setting_name === 'cell_power_range');

  Map_Default_Location.value = All_Setting_List.value.find(setting => setting.setting_name === 'map_default_location');
  if (Map_Default_Location.value) Set_Default_Map_Setting();

  Marker_Default_Icon.value = All_Setting_List.value.find(setting => setting.setting_name === 'marker_default_icon');
  Group_Default_Icon.value = All_Setting_List.value.find(setting => setting.setting_name === 'group_default_icon');

  if ( !Use_QLS_Users.value
    || !UpdateTime_Status_Range.value
    || !Marker_Grouping_Range.value
    || !Battery_Level_Range.value
    || !Cell_Power_Range.value
    || !Map_Default_Location.value
    || !Marker_Default_Icon.value
    || !Group_Default_Icon.value
  ) Set_Missing_Settings();
  // if (Map_Default_Location.value) Delete_Setting('map_default_location');
};
export const Set_Missing_Settings = async () => {
  if (!Use_QLS_Users.value) {
    const totalData = {
      setting_name: 'use_qls_users',
      setting_value: true,
    };
    await Post_Setting(totalData);
  }

  if (!UpdateTime_Status_Range.value) {
    const totalData = {
      setting_name: 'updatetime_status_range',
      setting_value: [
        { time: 60, color: '#00ff00', alpha: 0.5 },  // 초록색 (1분 이내)
        { time: 1800, color: '#ffff00', alpha: 0.5 }, // 노랑색 (30분 이내)
        { time: 9999, color: '#ff0000', alpha: 0.5 } // 빨강색 (30분 이상)
      ],
    };
    await Post_Setting(totalData);
  }

  if (!Marker_Grouping_Range.value) {
    const totalData = {
      setting_name: 'marker_grouping_range',
      setting_value: 10,
    };
    await Post_Setting(totalData);
  }

  if (!Battery_Level_Range.value) {
    const totalData = {
      setting_name: 'battery_level_range',
      setting_value: {
        low: 30,
        high: 70,
      },
    };
    await Post_Setting(totalData);
  }

  if (!Cell_Power_Range.value) {
    const totalData = {
      setting_name: 'cell_power_range',
      setting_value: {
        low: -120,
        high: -90,
      },
    };
    await Post_Setting(totalData);
  }

  if (!Map_Default_Location.value) {
    const totalData = {
      setting_name: 'map_default_location',
      setting_value: {
        // latitude: 37.3757,
        // longitude: 127.1113,
        latitude: 6.189,
        longitude: 31.606,
        offlinemap: '/tiles/data/tilemap/{z}/{x}/{y}.png',
      },
    }
    await Post_Setting(totalData);
  }

  if (!Marker_Default_Icon.value) {
    const imageUrl = new URL("@/assets/images/logo.ico", import.meta.url).href;
    
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const file = new File([blob], "logo.ico", { type: "image/svg+xml" });

    await Set_Setting_Image("marker_default_icon", "{}", file, "POST");
  }

  if (!Group_Default_Icon.value) {
    const imageUrl = new URL("@/assets/images/people.svg", import.meta.url).href;
    
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const file = new File([blob], "people.svg", { type: "image/svg+xml" });

    await Set_Setting_Image("group_default_icon", "{}", file, "POST");
  }

  await Get_All_Settings_FromServer();
};

export const Get_All_Settings = () => {
  return All_Setting_List.value
};
export const Get_Setting = (s_name) => {
  if(!All_Setting_List.value) return;
  const findV = All_Setting_List.value.find(setting => setting.setting_name === s_name);
  if (findV) {
    const value = JSON.parse(JSON.stringify(All_Setting_List.value.find(setting => setting.setting_name === s_name)?.setting_value));
    return value;
  } else {
    return null;
  }
};
export const Get_Setting_Image = (s_name) => {
  if(!All_Setting_List.value) return;
  const findV = All_Setting_List.value.find(setting => setting.setting_name === s_name);
  if (findV) {
    const value = All_Setting_List.value.find(setting => setting.setting_name === s_name)?.setting_value.image;
    return imageUrl() + value;
  } else {
    return null;
  }
}
export const Modify_Setting = async (s_name, data) => {
  if (!s_name) return;

  const totalData = {
    setting_name: s_name,
    setting_value: data,
  };
  await Put_Setting(totalData);

  await Get_All_Settings_FromServer();
};

const Post_Setting = async (totalData) => {
  try {
    const jsonData = JSON.stringify(totalData);
    const response = await SERVER_REQUEST('setting', 'POST', jsonData);

    if (response.message) {
      // SendErrorLog('Setting', { 
      //   name: 'Save success',
      //   message: totalData.setting_name,
      //   stack: `Saved data : ${totalData.setting_value}`,
      // });
    } else {
      SendErrorLog(`Setting-Save(${totalData.setting_name})`, response);  
    }
    
  } catch (error) {
    SendErrorLog(`Setting-Save(${totalData.setting_name})`, error);
  }
};

const Put_Setting = async (totalData) => {
  try {
    const jsonData = JSON.stringify(totalData);
    const response = await SERVER_REQUEST('setting', 'PUT', jsonData);

    if (response.message) {
      // SendErrorLog('Setting', { 
      //   name: 'Modify success',
      //   message: totalData.setting_name,
      //   stack: `Old data : ${Get_Setting(totalData.setting_name)} \n
      //           New data : ${totalData.setting_value}`,
      // });
    } else {
      SendErrorLog(`Setting-Modify(${totalData.setting_name})`, response);  
    }
    
  } catch (error) {
    SendErrorLog(`Setting-Modify(${totalData.setting_name})`, error);
  }
};

export const Set_Setting_Image = async (setName, setValue, image, method) => {
  try {
    const formData = new FormData();
    formData.append("setting_name", setName);
    formData.append("setting_value", setValue);
    formData.append("image", image);

    const response = await SERVER_REQUEST('setting', method, formData, true, null);
    if (response.message) {
      // SendErrorLog('Setting', { 
      //   name: 'Set image success',
      //   message: setName,
      //   stack: `Set image : ${image}`,
      // });
    } else {
      SendErrorLog(`Setting-Image(${setName})`, response);  
    }
  } catch (error) {
    SendErrorLog(`Setting-Image(${setName})`, error);
  }
}

export const Delete_Setting = async (s_name) => {
  try {
    const totalData = {
      setting_name: s_name
    };
    const jsonData = JSON.stringify(totalData);
    const response = await SERVER_REQUEST('setting', 'DELETE', jsonData);

    if (response.message) {
      // SendErrorLog('Setting', { 
      //   name: 'Delete success',
      //   message: s_name,
      //   stack: `Deleted data : ${s_name}`,
      // });
    } else {
      SendErrorLog(`Delete-Setting(${s_name})`, response);
    }
    
  } catch (error) {
    SendErrorLog(`Delete-Setting(${s_name})`, error);
  }
};

export const Get_Image_Now_OR_Default = (s_name) => {
  if (!All_Setting_List.value) return;
  let findV = All_Setting_List.value.find(setting => setting.setting_name === s_name);
  if (findV) {
    const value = All_Setting_List.value.find(setting => setting.setting_name === s_name)?.setting_value.image;
    return imageUrl() + value;
  } else {
    s_name = s_name.replace("now", "default");
    findV = All_Setting_List.value.find(setting => setting.setting_name === s_name);
    if (findV) {
      const value = All_Setting_List.value.find(setting => setting.setting_name === s_name)?.setting_value.image;
      return imageUrl() + value;
    } else return null;
  }
}

export const setDefaultLatLng = async (e) => {
  if (!All_Setting_List.value) return;
  const { lat, lng } = e.latlng

  if (!Get_Setting("map_default_location")) {
    const totalData = {
      setting_name: 'map_default_location',
      setting_value: {
        latitude: lat,
        longitude: lng,
        offlinemap: 'https://qls.peratech.co.kr:28793/tiles/data/tilemap/{z}/{x}/{y}.png',
      },
    }
    await Post_Setting(totalData);
  } else {
    const data = {
      latitude: lat,
      longitude: lng,
      offlinemap: 'https://qls.peratech.co.kr:28793/tiles/data/tilemap/{z}/{x}/{y}.png',
    }
    await Modify_Setting("map_default_location", data);
  }
}





//#region 배포 구분용
// export const Company_Name = ref("Qubicom_Dev");
// export const Company_Name = ref("Simsys_Dev");
export const Company_Name = ref("Simsys_Real");
//#endregion


//#region 이사님 Needs
/*

250731
혼자 동떨어져있는 단말기 알림

*/
//#endregion